module.exports = __webpack_public_path__ + "static/media/icon-12.6ee27df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-12.png
// module id = 2565
// module chunks = 0